'use client';

import { CachePublicRecord, TolgeeProvider, TolgeeStaticData } from '@tolgee/react';
import { useRouter } from 'next/navigation';
import React, { useEffect, memo } from 'react';
import { TolgeeBase } from './shared';

type Props = {
  staticData: TolgeeStaticData | CachePublicRecord[];
  language: string;
  children: React.ReactNode;
};

export const tolgee = TolgeeBase().init();

export const TolgeeNextProvider = memo(({ language, children, staticData }: Props) => {
  // synchronize SSR and client first render
  const router = useRouter();

  useEffect(() => {
    const { unsubscribe } = tolgee.on('permanentChange', () => {
      // refresh page when there is a translation update
      router.refresh();
    });

    return () => unsubscribe();
  }, [router]);

  return (
    <TolgeeProvider tolgee={tolgee} options={{ useSuspense: false }} ssr={{ language, staticData }}>
      {children}
    </TolgeeProvider>
  );
});
